import { apiRequest } from '@/core';
import { type Member } from '@/types';
import { type FetchMembersRequestParams } from './types';

export const fetchMembersRequest = async ({
  propertyId,
}: FetchMembersRequestParams) =>
  apiRequest<Member[]>({
    endpoint: `api/members/${propertyId}`,
  });
